import { useEffect, useState } from "react";
import { api, fmt, imgUrl } from "@/lib/api";
import { ListingDetail } from "@/components/ListingDetail";
import { MapPin } from "lucide-react";

export default function HousesPage() {
  const [listings, setListings] = useState(null);
  const [sub, setSub] = useState("Mansions and estates across Los Angeles county available for music videos, film, television, events, photo and brand shoots.");
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    api.get("/listings", { params: { type: "house" } }).then((r) => setListings(r.data)).catch(() => setListings([]));
    api.get("/site/content").then((r) => {
      if (r.data?.site_text?.houses_sub) setSub(r.data.site_text.houses_sub);
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="houses-page">
      <div className="max-w-7xl mx-auto px-6 pt-20 pb-12">
        <p className="text-xs tracking-[0.4em] uppercase text-brand mb-4">Locations</p>
        <h1 className="font-display text-6xl sm:text-7xl text-white mb-4">Houses</h1>
        <p className="text-sm md:text-base text-zinc-400 max-w-3xl leading-relaxed">{sub}</p>
        <p className="text-lg md:text-xl text-white font-semibold tracking-[0.15em] mt-4">4 HOUR MINIMUM • PRICES SUBJECT TO CHANGE</p>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-20">
        {listings === null ? (
          <p className="text-zinc-500">Loading…</p>
        ) : listings.length === 0 ? (
          <p className="text-zinc-500 text-sm">Properties being added.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {listings.map((l) => (
              <button key={l.id} data-testid={`listing-card-${l.id}`} onClick={() => setDetail(l)}
                className="group text-left border border-white/10 hover:border-brand/60 transition-colors duration-300 overflow-hidden hover:-translate-y-1">
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={imgUrl(l.images?.[0])} alt={l.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <h2 className="font-display text-2xl text-white">{l.title}</h2>
                  {l.location && (
                    <p className="text-xs text-zinc-500 mt-1 flex items-center gap-1">
                      <MapPin className="w-3 h-3" /> {l.location}
                    </p>
                  )}
                  {l.price_tiers?.["4"] && (
                    <p className="text-sm text-zinc-300 mt-3">
                      From <span className="text-brand font-semibold">{fmt(l.price_tiers["4"])}</span> / 4 hrs
                    </p>
                  )}
                  <span className="inline-block text-xs tracking-widest uppercase text-brand mt-4">View & Book</span>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
      <ListingDetail listing={detail} type="house" open={!!detail} onClose={() => setDetail(null)} />
    </div>
  );
}
